export enum NotificationType {
  Error = "error"
};

export declare type Notification = {
  type: NotificationType;
  message: string;
};
